import { Theme } from '@src/theme/types';

import { Mode, Preset } from './types';

export function backgroundColorGetter(
  preset: Preset,
  theme: Theme,
  mode?: Mode
) {
  const { colors } = theme;
  const isContained = mode === 'contained';
  switch (preset) {
    case 'primary':
      return isContained ? colors.primary : colors.transparent;
    case 'secondary':
      return isContained ? colors.secondary : colors.transparent;
    default:
      return colors.transparent;
  }
}

export function rippleColorGetter(preset: Preset, theme: Theme) {
  const { colors } = theme;
  switch (preset) {
    case 'primary':
      return colors.primary;
    case 'secondary':
      return colors.secondary;
    default:
      return colors.primary;
  }
}

export function labelColorGetter(preset: Preset, theme: Theme, mode?: Mode) {
  const isContained = mode === 'contained';
  switch (preset) {
    case 'primary':
      return isContained ? theme.colors.onPrimary : theme.colors.primary;
    case 'secondary':
      return isContained ? theme.colors.onSecondary : theme.colors.secondary;
    default:
      return theme.colors.text;
  }
}
